import React from "react";
import { COLOR_PRIMARY } from "../../constants/colors";

const IconOffer1 = ({ color = {COLOR_PRIMARY} }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="39.76"
      height="39.76"
      viewBox="0 0 39.76 39.76"
    >
      <defs>
        <clipPath id="clipPath">
          <rect width="39.76" height="39.76" fill="none" />
        </clipPath>
      </defs>
      <g
        id="Grupo_22357"
        data-name="Grupo 22357"
        transform="translate(-0.007 0)"
      >
        <g id="Grupo_22356" data-name="Grupo 22356">
          <path
            id="Vector_617_Stroke_"
            data-name="Vector 617 (Stroke)"
            d="M12.727.444a1.917,1.917,0,0,1,.245,2.7l-9.583,11.5A1.917,1.917,0,1,1,.444,12.19L10.028.69A1.917,1.917,0,0,1,12.727.444Z"
            transform="translate(13.179 12.213)"
            fill={color}
          />
          <g
            id="Cuadrícula_de_repetición_15"
            data-name="Cuadrícula de repetición 15"
            transform="translate(0.007 0)"
            clipPath="url(#clipPath)"
          >
            <g
              id="Grupo_22355"
              data-name="Grupo 22355"
              transform="translate(-0.007 0)"
            >
              <path
                id="Ellipse_201"
                data-name="Ellipse 201"
                d="M5.75,2.875A2.875,2.875,0,1,1,2.875,0,2.875,2.875,0,0,1,5.75,2.875Z"
                transform="translate(12.22 12.213)"
                fill={color}
              />
              <path
                id="Ellipse_202"
                data-name="Ellipse 202"
                d="M5.75,2.875A2.875,2.875,0,1,1,2.875,0,2.875,2.875,0,0,1,5.75,2.875Z"
                transform="translate(21.804 21.796)"
                fill={color}
              />
              <path
                id="Star_4_Stroke_"
                data-name="Star 4 (Stroke)"
                d="M19.887,39.76a5.755,5.755,0,0,1-3.73-1.374L13.721,36.31a1.905,1.905,0,0,0-1.091-.452L9.438,35.6a5.751,5.751,0,0,1-5.275-5.274l-.255-3.192a1.9,1.9,0,0,0-.452-1.091L1.381,23.609a5.749,5.749,0,0,1,0-7.458l2.076-2.437a1.9,1.9,0,0,0,.452-1.091l.255-3.191A5.751,5.751,0,0,1,9.438,4.156L12.63,3.9a1.9,1.9,0,0,0,1.091-.452l2.437-2.076a5.75,5.75,0,0,1,7.459,0L26.053,3.45a1.9,1.9,0,0,0,1.091.452l3.192.255A5.75,5.75,0,0,1,35.61,9.431l.255,3.191a1.905,1.905,0,0,0,.452,1.091l2.077,2.437a5.751,5.751,0,0,1,0,7.458l-2.077,2.437a1.905,1.905,0,0,0-.452,1.091l-.255,3.192A5.75,5.75,0,0,1,30.336,35.6l-3.192.255a1.91,1.91,0,0,0-1.091.452l-2.436,2.076A5.755,5.755,0,0,1,19.887,39.76Zm0-35.927a1.915,1.915,0,0,0-1.243.458L16.207,6.368a5.715,5.715,0,0,1-3.272,1.355l-3.191.255A1.908,1.908,0,0,0,7.985,9.735L7.73,12.928A5.72,5.72,0,0,1,6.375,16.2L4.3,18.636a1.907,1.907,0,0,0,0,2.487L6.375,23.56A5.714,5.714,0,0,1,7.73,26.832l.255,3.192a1.908,1.908,0,0,0,1.759,1.758l3.191.255a5.715,5.715,0,0,1,3.272,1.355l2.437,2.077a1.917,1.917,0,0,0,2.486,0l2.437-2.077a5.715,5.715,0,0,1,3.272-1.355l3.191-.255a1.91,1.91,0,0,0,1.759-1.758l.255-3.192A5.712,5.712,0,0,1,33.4,23.56l2.077-2.437a1.91,1.91,0,0,0,0-2.487L33.4,16.2a5.717,5.717,0,0,1-1.354-3.272L31.79,9.735a1.91,1.91,0,0,0-1.759-1.758L26.84,7.723a5.715,5.715,0,0,1-3.272-1.355L21.13,4.291A1.917,1.917,0,0,0,19.887,3.833Z"
                fill={color}
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default IconOffer1;
